export default __webpack_public_path__ + "62159d7399e24cf3a50ee12bf7f7897f.svg";